/**
 * Generated by orval v8.20.0.
 * Do not edit manually.
 * Hub API v2.0.0.
 */

import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import type { AgencyConsumerGet200 } from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
    | HttpParams
    | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: { includeHeaders?: string[] } | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({ providedIn: 'root' })
export class ConsumersService {
  private readonly http = inject(HttpClient);
  /**
   * Returns the consumer the session's agency belongs to, with its subscription and how much of it is used: agent seats, superusers not counted, and active sub-agencies, the super agency not counted. A limit of 0 means unlimited. Managers of the agency only, sub-agency managers included.<br><br>Replaces `GET /v1.5/agent/account/consumer` of the legacy agent API: the subscription and the counts are nested rather than flat, `subscription_name` is `subscription.name`, `subagency_enabled` is `subscription.subagencies_enabled`, and `agent_count`, `agent_limit`, `subagency_count` and `subagency_limit` are `limits.agents.used`, `limits.agents.limit`, `limits.subagencies.used` and `limits.subagencies.limit`, the body of `GET /agw/consumers/{consumer_id}/limits`. All of them are always present, where the legacy sent them to the super agency alone.
   * @summary Get the consumer
   */
  agencyConsumerGet<TData = AgencyConsumerGet200>(
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  agencyConsumerGet<TData = AgencyConsumerGet200>(
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  agencyConsumerGet<TData = AgencyConsumerGet200>(
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  agencyConsumerGet<TData = AgencyConsumerGet200>(
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${environment.hubApiUrl}/agency/consumer`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${environment.hubApiUrl}/agency/consumer`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${environment.hubApiUrl}/agency/consumer`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}
